module.exports = __webpack_public_path__ + "img/rt-seat.ac8da594.jpg";